import React from 'react';
import SimpleBalloon from "./SimpleBalloon";

const PlanCard = ({ title, description, price, discountLabel, feature, discountedPrice, isCampaignPeriod }) => {
  return (
    <article className="plan-card">
      <header className="plan-header">
        <h2 className="plan-title">{title}</h2>
      </header>
      <p className="plan-description" dangerouslySetInnerHTML={{ __html: description }} />
      <div className="price-container">
        {isCampaignPeriod ? (
          // キャンペーン期間中の料金表示

          <div>
            <div className="price-wrapper original-price">
              <div class="price-group">
                <span className="price-label">月額</span>
                <span className="price strikethrough">{price}</span>
                <span className="price-currency">円</span>
              </div>
            </div>
            <SimpleBalloon text="期間限定" />
            <div className="price-wrapper discount-price">
              <span className="price-label">初月</span>
              <span className="price">{discountedPrice}</span>
              <span className="price-currency">円</span>
            </div>
          </div>
        ) : (
          // 通常の料金表示
          <div className="price-wrapper">
            <span className="price-label">月額</span>
            <span className="price">{price}</span>
            <span className="price-currency">円</span>
          </div>
        )}
      </div>
      {discountLabel && (
        <p className="discount-label" dangerouslySetInnerHTML={{ __html: discountLabel }} />
      )}
      <p className="plan-feature">{feature}</p>
    </article>
  );
};

export default PlanCard;

